module.exports = (($) => {
    class PageTitle {}
    $(document).ajaxComplete(function(event, request) {
        pageTitle = request.getResponseHeader('page-title');
        console.log('pageTitle:');
        console.log(pageTitle);
        if (pageTitle !== undefined && pageTitle !== null && pageTitle.length) {
            document.title = pageTitle;
        }
    });
    return PageTitle
})(jQuery)
